"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTracking = exports.TrackingProvider = void 0;
const react_1 = __importDefault(require("react"));
const amplitude_1 = __importDefault(require("./amplitude"));
const useIsInternal_1 = require("./useIsInternal");
const getErrorProviderMissing = () => new Error('An "AnalyticProvider" needs to be implemented');
const TrackingContext = react_1.default.createContext({
    optIn: () => {
        throw getErrorProviderMissing();
    },
    track: () => {
        throw getErrorProviderMissing();
    },
    trackCustom: () => {
        throw getErrorProviderMissing();
    },
    trackError: () => {
        throw getErrorProviderMissing();
    },
    setUserId: () => {
        throw getErrorProviderMissing();
    }
});
const TrackingProvider = ({ amplitudeApiKey, children, customEventPrefix, defaultClickTracking, locale, anonymize = true }) => {
    const internal = (0, useIsInternal_1.useIsInternal)();
    const amplitude = react_1.default.useRef(new amplitude_1.default({
        apiKey: amplitudeApiKey,
        defaultClickTracking,
        internal,
        locale,
        anonymize
    }));
    react_1.default.useEffect(() => {
        const amplitudeCurrent = amplitude.current;
        amplitudeCurrent.init();
        return () => {
            amplitudeCurrent.destroy();
        };
    }, []);
    react_1.default.useEffect(() => {
        amplitude.current.setLocale(locale);
    }, [locale]);
    const value = react_1.default.useMemo(() => ({
        optIn: (optInValue) => {
            amplitude.current.optIn(optInValue);
        },
        track: (event, options) => {
            // @ts-ignore
            amplitude.current.track(event, options);
        },
        trackCustom: (event, options) => {
            amplitude.current.trackCustom(`${customEventPrefix}: ${event}`, options);
        },
        trackError: (error) => {
            amplitude.current.track('Error', {
                'Error Message': error.message
            });
        },
        setUserId: (userId) => {
            amplitude.current.setUserId(userId);
        }
    }), [customEventPrefix]);
    return react_1.default.createElement(TrackingContext.Provider, { value: value }, children);
};
exports.TrackingProvider = TrackingProvider;
const useTracking = () => react_1.default.useContext(TrackingContext);
exports.useTracking = useTracking;
